<template>
  <div class="frame-parent">
    <div class="frame-group">
      <div class="parent">
        <b class="b">
          <span>كيف غيّر منهج المعايشة </span>
          <span class="span">مستوى أبنائهم</span>
          <span> في الإنجليزية</span>
        </b>

        <!-- Carousel Container -->
        <div class="carousel-container">
          <!-- Left Navigation Button -->
          <button
            class="nav-button nav-left"
            @click="moveLeft"
            aria-label="Previous reviews"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
            </svg>
          </button>

          <!-- Carousel Track -->
          <div class="carousel-track">
            <!-- Far Left Card -->
            <div v-if="reviewImages[leftIndex2]" class="review-card far-left-card">
              <img
                :src="reviewImages[leftIndex2]"
                alt="Parent testimonial"
                class="review-image"
                loading="lazy"
              />
            </div>

            <!-- Left Card -->
            <div v-if="reviewImages[leftIndex1]" class="review-card left-card">
              <img
                :src="reviewImages[leftIndex1]"
                alt="Parent testimonial"
                class="review-image"
                loading="lazy"
              />
            </div>

            <!-- Center Card (Main) -->
            <div v-if="reviewImages[centerIndex]" class="review-card center-card">
              <img
                :src="reviewImages[centerIndex]"
                alt="Parent testimonial"
                class="review-image"
                loading="lazy"
              />
            </div>

            <!-- Right Card -->
            <div v-if="reviewImages[rightIndex1]" class="review-card right-card">
              <img
                :src="reviewImages[rightIndex1]"
                alt="Parent testimonial"
                class="review-image"
                loading="lazy"
              />
            </div>

            <!-- Far Right Card -->
            <div v-if="reviewImages[rightIndex2]" class="review-card far-right-card">
              <img
                :src="reviewImages[rightIndex2]"
                alt="Parent testimonial"
                class="review-image"
                loading="lazy"
              />
            </div>
          </div>

          <!-- Right Navigation Button -->
          <button
            class="nav-button nav-right"
            @click="moveRight"
            aria-label="Next reviews"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'

// Load all review images from public folder
const reviewImages = [
  '/reviews/Group 1172147854.webp',
  '/reviews/Group 1172147855.webp',
  '/reviews/Group 1172147856.webp',
  '/reviews/Group 1172147857.webp',
  '/reviews/Group 1172148131.webp',
  '/reviews/Group 1172148132.webp',
  '/reviews/Group 1172148133.webp',
  '/reviews/Group 1172148134.webp',
  '/reviews/Group 1172148135.webp',
  '/reviews/Group 1172148136.webp',
  '/reviews/Group 1172148137.webp',
  '/reviews/Group 1172148138.webp',
  '/reviews/Group 1172148139.webp',
  '/reviews/Group 1172148140.webp',
  '/reviews/Group 1172148141.webp',
  '/reviews/Group 1172148142.webp',
  '/reviews/Group 1172148143.webp',
  '/reviews/Group 1172148144.webp',
  '/reviews/Group 1172148145.webp',
  '/reviews/Group 1172148146.webp',
  '/reviews/Group 1172148147.webp',
  '/reviews/Group 1172148148.webp',
  '/reviews/Group 1172148149.webp',
  '/reviews/Group 1172148150.webp',
  '/reviews/Group 1172148151.webp',
  '/reviews/Group 1172148152.webp',
  '/reviews/Group 1172148154.webp',
  '/reviews/Group 1172148155.webp',
  '/reviews/Group 1172148156.webp',
  '/reviews/Group 1172148157.webp',
  '/reviews/Group 1172148158.webp',
  '/reviews/Group 1172148160.webp',
  '/reviews/Group 1172148161.webp',
  '/reviews/Group 1172148162.webp',
  '/reviews/Group 1172148163.webp',
  '/reviews/Group 1172148164.webp',
  '/reviews/Group 1172148165.webp',
]

const currentPosition = ref(0)

const centerIndex = computed(() => {
  return (currentPosition.value % reviewImages.length + reviewImages.length) % reviewImages.length
})

const leftIndex1 = computed(() => {
  return ((currentPosition.value - 1) % reviewImages.length + reviewImages.length) % reviewImages.length
})

const leftIndex2 = computed(() => {
  return ((currentPosition.value - 2) % reviewImages.length + reviewImages.length) % reviewImages.length
})

const rightIndex1 = computed(() => {
  return (currentPosition.value + 1) % reviewImages.length
})

const rightIndex2 = computed(() => {
  return (currentPosition.value + 2) % reviewImages.length
})

const moveLeft = () => {
  currentPosition.value -= 1
}

const moveRight = () => {
  currentPosition.value += 1
}
</script>

<style scoped>
.frame-parent {
  width: 100%;
  height: 870px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 70px 80px;
  box-sizing: border-box;
  text-align: center;
  font-size: 48px;
  color: #fff;
  font-family: Poppins;
}

.frame-group {
  width: 100%;
  height: 870px;
  position: absolute;
  margin: 0 !important;
  top: 0px;
  right: 0px;
  left: 0px;
  background-color: #fff;
  overflow: hidden;
  flex-shrink: 0;
  z-index: 0;
}

.frame-child2 {
  position: absolute;
  bottom: -361px;
  left: 1px;
  background: linear-gradient(270deg, rgba(255, 255, 255, 0), #fff 67.79%);
  width: 437px;
  height: 334px;
}

.frame-child3 {
  position: absolute;
  right: -473px;
  bottom: -361px;
  background: linear-gradient(270deg, rgba(255, 255, 255, 0), #fff 67.79%);
  width: 480px;
  height: 334px;
  transform: rotate(180deg);
  transform-origin: 0 0;
}

.parent {
  position: absolute;
  top: calc(50% - 425px);
  left: calc(50% - 853px);
  width: 1706px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 70px;
  color: #313131;
  font-family: 'DIN Next LT Arabic';
}

.b {
  align-self: stretch;
  position: relative;
  line-height: 120%;
  text-transform: uppercase;
  opacity: 0.9;
}

.span {
  color: #f47d21;
}

/* Carousel Container */
.carousel-container {
  width: 100%;
  max-width: 1600px;
  position: relative;
  height: clamp(350px, 80vw, 600px);
  display: flex;
  align-items: center;
  justify-content: center;
  perspective: 1500px;
  box-sizing: border-box;
}

/* Carousel Track */
.carousel-track {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0px;
  transform-style: preserve-3d;
}

/* Review Cards */
.review-card {
  position: relative;
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
}

/* Center Card (Main) */
.center-card {
  z-index: 10;
  transform: scale(1);
  background: transparent;
}

.center-card .review-image {
  width: 350px;
  height: 600px;
  object-fit: contain;
  display: block;
}

.center-card:hover .review-image {
  transform: scale(1.02);
}

/* Side Cards (Adjacent) */
.left-card,
.right-card {
  position: absolute;
  width: 300px;
  height: 515px;
  overflow: hidden;
  opacity: 0.9;
  z-index: 5;
  background: transparent;
}

.left-card .review-image,
.right-card .review-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.left-card {
  top: 50%;
  left: calc(50% - 450px);
  transform: translateY(-50%);
}

.right-card {
  top: 50%;
  right: calc(50% - 450px);
  transform: translateY(-50%);
}

/* Far Side Cards */
.far-left-card,
.far-right-card {
  position: absolute;
  width: 250px;
  height: 430px;
  overflow: hidden;
  opacity: 0.7;
  z-index: 2;
  background: transparent;
}

.far-left-card .review-image,
.far-right-card .review-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.far-left-card {
  top: 50%;
  left: calc(50% - 700px);
  transform: translateY(-50%);
}

.far-right-card {
  top: 50%;
  right: calc(50% - 700px);
  transform: translateY(-50%);
}

/* Navigation Buttons */
.nav-button {
  position: absolute;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #0B5A7D;
  color: white;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 40;
  box-shadow: 0 6px 20px rgba(11, 90, 125, 0.4);
}

.nav-button:hover {
  background: #f47d21;
  transform: scale(1.15);
  box-shadow: 0 8px 25px rgba(244, 125, 33, 0.5);
}

.nav-button:active {
  transform: scale(1.05);
}

.nav-button:disabled {
  opacity: 0.3;
  cursor: not-allowed;
  background: #ccc;
}

.nav-button:disabled:hover {
  transform: scale(1);
  box-shadow: 0 6px 20px rgba(11, 90, 125, 0.4);
}

.nav-button svg {
  width: 28px;
  height: 28px;
  stroke-width: 3;
}

.nav-left {
  left: 20px;
}

.nav-right {
  right: 20px;
}

@media (max-width: 1400px) {
  .carousel-container {
    height: 700px;
  }

  .center-card .review-image {
    width: 310px;
    height: 530px;
  }

  .left-card,
  .right-card {
    width: 260px;
    height: 445px;
  }

  .left-card {
    left: 30px;
  }

  .right-card {
    right: 30px;
  }

  .far-left-card,
  .far-right-card {
    width: 220px;
    height: 375px;
  }

  .far-left-card {
    left: -150px;
  }

  .far-right-card {
    right: -150px;
  }
}

@media (max-width: 1200px) {
  .frame-parent {
    height: auto;
    min-height: 600px;
    padding: 50px 40px;
  }

  .frame-group {
    height: auto;
    min-height: 600px;
  }

  .parent {
    position: relative;
    top: auto;
    left: auto;
    width: 100%;
    max-width: 1200px;
    gap: 40px;
    padding: 40px 20px;
  }

  .b {
    font-size: 36px;
  }

  .carousel-container {
    height: 600px;
  }

  .center-card .review-image {
    width: 280px;
    height: 480px;
  }

  .left-card,
  .right-card {
    width: 230px;
    height: 395px;
  }

  .far-left-card,
  .far-right-card {
    display: none;
  }

  .nav-button {
    width: 48px;
    height: 48px;
  }

  .nav-button svg {
    width: 22px;
    height: 22px;
  }
}

@media (max-width: 768px) {
  .frame-parent {
    padding: 30px 20px;
  }

  .parent {
    gap: 30px;
    padding: 30px 10px;
  }

  .b {
    font-size: 28px;
  }

  .frame-child2,
  .frame-child3 {
    display: none;
  }

  .carousel-container {
    height: clamp(450px, 80vw, 500px);
  }

  .center-card .review-image {
    width: clamp(220px, 60vw, 250px);
    height: clamp(380px, 100vw, 430px);
  }

  .left-card,
  .right-card {
    display: none;
  }

  .nav-button {
    width: clamp(40px, 9vw, 44px);
    height: clamp(40px, 9vw, 44px);
  }

  .nav-button svg {
    width: clamp(20px, 4.5vw, 22px);
    height: clamp(20px, 4.5vw, 22px);
  }

  .nav-left {
    left: clamp(8px, 2vw, 10px);
  }

  .nav-right {
    right: clamp(8px, 2vw, 10px);
  }
}

@media (max-width: 480px) {
  .frame-parent {
    padding: 20px 15px;
  }

  .parent {
    gap: 20px;
    padding: 20px 5px;
  }

  .b {
    font-size: 22px;
    line-height: 140%;
  }

  .carousel-container {
    height: clamp(480px, 100vw, 520px);
  }

  .center-card .review-image {
    width: clamp(200px, 55vw, 230px);
    height: clamp(340px, 95vw, 390px);
  }

  .nav-button {
    width: clamp(36px, 8vw, 40px);
    height: clamp(36px, 8vw, 40px);
  }

  .nav-button svg {
    width: clamp(18px, 4vw, 20px);
    height: clamp(18px, 4vw, 20px);
  }
}

@media (max-width: 380px) {
  .carousel-container {
    height: 460px;
  }

  .center-card .review-image {
    width: 190px;
    height: 330px;
  }

  .nav-button {
    width: 34px;
    height: 34px;
  }

  .nav-button svg {
    width: 17px;
    height: 17px;
  }
}
</style>
